export default {"src":"/_next/static/media/SubDesc2.18541eca.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};